export default __webpack_public_path__ + "static/media/image1.f7637432.png";